import React, { useState, useCallback, useMemo } from "react";
import "./styles.css";
import Gallery from "react-photo-gallery";
import FadeIn from "react-fade-in";
import Carousel, { Modal, ModalGateway } from "react-images";

export default function About() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const randomizedPhotos = useMemo(() => {
    return photos.map(photo => ({
      ...photo,
      width: Math.floor(Math.random() * 5) + 2,  // Random width between 2 and 10
      height: Math.floor(Math.random() * 5) + 2  // Random height between 2 and 10
    })).sort(() => Math.random() - 0.5);
  }, []);

  return (
    <FadeIn>
      <div className="homeContainer">
        <h1 className="galleryTitle">Gallery</h1>
        <p className="galleryDescription">
          This will be an ever-growing collection of our memories together.
        </p>
        <Gallery photos={randomizedPhotos} onClick={openLightbox} />
        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={randomizedPhotos.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
    </FadeIn>
  );
}

const photos = [
  {
    src: "/Images/100.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/101.jpg",
    width: 1,
    height: 1
  },
  {
    src: "/Images/102.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/103.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/104.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/105.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/106.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/107.jpg",
    width: 4,
    height: 8
  },
  {
    src: "/Images/108.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/109.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/110.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/111.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/112.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/113.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/114.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/115.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/116.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/117.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/118.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/119.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/120.jpg",
    width: 4,
    height: 3
  },

];
